import EmptyLayout from '/components/layouts/EmptyLayout'
import ForgotPassword from '/components/profile/ForgotPassword'

ForgotPassword.Layout = EmptyLayout

export default ForgotPassword
